var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnProfileCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_profile_camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5 10.875C12.5352 10.875 10.875 12.5352 10.875 14.5C10.875 16.4648 12.5352 18.125 14.5 18.125C16.4648 18.125 18.125 16.4648 18.125 14.5C18.125 12.5352 16.4648 10.875 14.5 10.875Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.168 6.04199H21.0432L17.7723 2.77103C17.5457 2.54441 17.2384 2.41706 16.918 2.41699H12.0846C11.7642 2.41706 11.4569 2.54441 11.2303 2.77103L7.95939 6.04199H4.83464C3.50184 6.04199 2.41797 7.12587 2.41797 8.45866V21.7503C2.41797 23.0831 3.50184 24.167 4.83464 24.167H24.168C25.5008 24.167 26.5846 23.0831 26.5846 21.7503V8.45866C26.5846 7.12587 25.5008 6.04199 24.168 6.04199ZM14.5013 20.542C11.2267 20.542 8.45964 17.7749 8.45964 14.5003C8.45964 11.2257 11.2267 8.45866 14.5013 8.45866C17.7759 8.45866 20.543 11.2257 20.543 14.5003C20.543 17.7749 17.7759 20.542 14.5013 20.542Z",
    fill: "#767676"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnProfileCamera);
export default __webpack_public_path__ + "static/media/icn_profile_camera.2325dc3ee5dab31a538df9fef35ae6d4.svg";
export { ForwardRef as ReactComponent };